import { TimeoutUtil } from 'src/utils/helper/timer'
import { ref } from 'vue'

export const errors = ref([])

export const globalValidators = ref([])

const StepObject = (options = {}) => {
  return {
    context: options.context || {},
    name: options.name,
    open: options.open || false,
    valid: options.valid || false,
    complete: options.complete || false,
    show: function () {
      this.open = true
    },
    errors: errors.value,
    set: function (options) {
      this.context = options.context
    },
    getErrors: function () {
      /**
       * Return {Array}
       */
      return this.errors
    },
    getErrorItems: function () {
      /**
       * Return {Array}
       */
      return this.errors
    },
    anyErrors: function () {
      /**
       * Return {Boolean}
       */
      const filteredErrorByStepper = []
      errors.value.filter(err => {
        const ifKeyExists = Object.keys(err).filter(error => error.includes(this.name))
        if (ifKeyExists.length) {
          filteredErrorByStepper.push(err)
        }
      })
      this.errors = filteredErrorByStepper
      return this.errors.length > 0
    },
    validate: function () {
      return new Promise(resolve => {
        if (typeof this.context.$validator === 'object') {
          const scopes = []
          const promises = [this.context.$validator.validateAll()]
          this.context.$validator.fields.map(f => {
            if (f.scope !== null && scopes.indexOf(f.scope) === -1) {
              scopes.push(f.scope)
            }
            /**
             * Set pristine state to false for font validator watched property
             */
            this.context.$validator.flag(`${f.scope}.${f.name}`, {
              pristine: false
            })
          })
          for (const s of scopes) {
            promises.push(this.context.$validator.validateAll(s))
          }
          Promise.all(promises).then(valid => {
            this.valid = valid.indexOf(false) === -1 && this.complete === true
            resolve(this.valid)
          })
        } else {
          resolve(false)
        }
      })
    }
  }
}

const getSubmissionSteps = () => {
  return [
    StepObject({
      name: 'upload'
    }),
    StepObject({
      name: 'prices'
    }),
    StepObject({
      name: 'descriptions'
    }),
    StepObject({
      name: 'graphics'
    })
  ]
}

const SubmissionObject = {
  steps: getSubmissionSteps(),
  step: function (name) {
    const obj = this.steps.filter(v => v.name === name)
    return obj[0] || {}
  },
  hasErrors: function () {
    return this.steps.some(step => step.anyErrors())
  },

  getErrors: function () {
    const allErrors = [].concat.apply(
      [],
      this.steps.map((step, index) => {
        const error = step.getErrorItems()
        return error.map(e => {
          return e
        })
      })
    )
    const ret = this.getRequiredErrors(allErrors)
      .concat(this.getNonRequiredErrors(allErrors))
      .map(item => {
        return {
          step: item.step,
          msg: Object.values(item)[0]
        }
      })
      .sort((a, b) => a.step - b.step)
    return ret || []
  },
  getRequiredErrors: function (allErrors) {
    let required = []
    allErrors
      .filter(err => err.rule === 'required')
      .forEach(item => {
        if (item.msg && item.msg.indexOf('is required.') !== -1) {
          const field = item.msg.match('The (.*) field is')
          if ((field || [])[1]) {
            required.push(field[1].trim())
          }
        } else {
          required.push(item.msg)
        }
      })
    required = Array.from(new Set(required))
    /**
     * Combine «required» errors and put them to top of the error list
     */
    return required.length > 0
      ? [
          {
            msg: `${this.$t('pages.submissions.index.required_errors')}: ${required.join(', ')}`,
            step: -1
          }
        ]
      : []
  },
  getNonRequiredErrors: function (allErrors) {
    return allErrors.filter(err => err.rule !== 'required') || []
  },
  validateAll: function () {
    return new Promise(resolve => {
      const promises = []
      for (const step of this.steps) {
        promises.push(step.validate())
      }
      Promise.all(promises).then(valids => {
        resolve(!valids.some(v => v === false))
      })
    })
  },
  getStep: function (name) {
    return this.steps.filter(s => s.name === name)[0] || {}
  },
  getStepsWithErrors: function () {
    return Array.from(new Set(this.getErrors().map(e => e.step)))
  },
  getStepErrors: function (step) {
    return this.getErrors().filter(e => e.step === step) || []
  },
  refreshs: [],
  builds: [],
  readyStates: [],
  readyComplete: false,
  updateTimer: TimeoutUtil(),
  reset: function () {
    this.refreshs = []
    this.builds = []
    this.readyStates = []
    this.updateTimer.clear()
    this.readyComplete = true
    this.steps = getSubmissionSteps()
  }
}

export { StepObject, SubmissionObject }
